import { bl_applet_to_store_trending_link_RowClass } from "../../dbschema";
import { BaseContainerModel } from "../base-container.model";

export class AppletToStoreTrendingLinksContainerModel extends BaseContainerModel {
    bl_applet_to_store_trending_link: bl_applet_to_store_trending_link_RowClass
}